<div *ngIf="loadingService.loading$ | async">
  <app-spinner [fullSpinner]="true"></app-spinner>
</div>

<p-toast></p-toast>

<div class="card-map">
  <section class="wrapper">
    <div class="wrapper-div">
      <div class="header-comp-logo">
        <img
          class="montralogo2024"
          src="../../../../assets/img/common/montralogo2024.png"
          alt="logo"
        />
      </div>
      <div class="header-menu"></div>
    </div>
  </section>
  <section class="p-2" *ngIf="isError">
    @for (msg of messages; track $index) {
      <p-message [severity]="$any(msg.severity)" [closable]="false">{{
        msg.summary
      }}</p-message>
    }
  </section>
  <section class="vehicle-wrapper" *ngIf="!isError && isLoaded">
    <div class="vehicle-info">
      Click on any vehicle on the map to track its live location and view
      detailed information.
    </div>
    <div class="counter" *ngIf="timeLeft">
      <div class="count-box">
        <div class="count-value">{{ timeLeft.days }}</div>
        <div class="count-label">Days</div>
      </div>
      <div class="seperation">|</div>
      <div class="count-box">
        <div class="count-value">{{ timeLeft.hours }}</div>
        <div class="count-label">HH</div>
      </div>
      <div class="seperation">:</div>
      <div class="count-box">
        <div class="count-value">{{ timeLeft.minutes }}</div>
        <div class="count-label">MM</div>
      </div>
      <div class="seperation">:</div>
      <div class="count-box">
        <div class="count-value">{{ timeLeft.seconds }}</div>
        <div class="count-label">SS</div>
      </div>
    </div>
  </section>
  <div class="map_wrapper">
    <div class="map-type-pos">
      <app-map-type-view
        [maps]="map"
        [trafficLive]="trafficLive"
      ></app-map-type-view>
    </div>

    <div id="live-map"></div>
  </div>
</div>
